<template>
  <div class="mt-4 container-fluid">
    <div class="d-flex justify-content-between mb-4">
      <h3>{{ translations.page_title }}</h3>
    </div>
    <div class="d-flex align-items-center justify-content-between">
      <filters
      :loading="loading"
      ref="filters"
      @apply-filters="applyFilters"/>
      <export-button :filters="persistFilters" filename="transactions_list" />
    </div>

    <div class="w-100">
      <b-tabs content-class="mt-3">
        <b-tab
          v-for="(tab, index) in tabs"
          :key="tab.key"
          :title="tab.title"
          :active="selectedTab === index"
          @click="selectTab(index)">
          <b-container fluid>
            <component
              v-if="selectedTab === index"
              :is="tab.component"
              :ref="tab.key"
              @mounted="onChildMounted"/>
          </b-container>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import translations from '@/translations';
import ExportButton from '@/components/Financial/ExportTransactionsButton.vue';
import FinanceListTransaction from './listTransaction.vue';
import FinanceListBlockTransaction from './listBlockTransaction.vue';
import Filters from './filters.vue';

export default {
  name: 'FinanceTransactionsList',
  components: {
    Filters,
    ExportButton,
    FinanceListTransaction,
    FinanceListBlockTransaction,
  },
  data() {
    return {
      translations: translations.finance.transactions,
      selectedTab: 0,
      tabs: [
        {
          key: 'transactions',
          title: translations.finance.transactions.tabs.transactions,
          component: 'FinanceListTransaction',
        },
        {
          key: 'blocked_transactions',
          title: translations.finance.transactions.tabs.blocked_transactions,
          component: 'FinanceListBlockTransaction',
        },
      ],
      persistFilters: {},
      loading: true,
    };
  },
  async beforeMount() {
    this.loading = true;
    // persist selected tab
    const tab = this.$route.query?.tab || 'transactions';
    const tabIndex = this.tabs.findIndex(t => t.key === tab);
    if (tabIndex !== -1) this.selectedTab = tabIndex;
    this.restoreFiltersFromQuery();
    this.loading = false;
  },
  async mounted() {
    this.$refs.filters.recoverFiltersFromURL(this.persistFilters);
  },
  methods: {
    async selectTab(index) {
      this.selectedTab = index;

      await this.sendFiltersToChildren();

      const currentRoute = this.$route;
      this.persistFilters.has_problematic_block_flags = this.tabs[this.selectedTab].key === 'blocked_transactions';
      this.$router.replace({
        path: currentRoute.path,
        query: {
          tab: this.tabs[index].key,
          ...this.persistFilters,
        },
      }).catch(() => {});
    },
    async applyFilters(filters = {}) {
      this.persistFilters = {
        has_problematic_block_flags: this.tabs[this.selectedTab].key === 'blocked_transactions',
      };

      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          this.persistFilters[key] = filters[key];
        }
      });

      this.setParamsToQuery();
      await this.sendFiltersToChildren();
    },
    async onChildMounted() {
      await this.sendFiltersToChildren();
    },
    async sendFiltersToChildren() {
      const children = this.$refs[this.tabs[this.selectedTab].key];
      if (children?.length) await children[0].applyFilters(this.persistFilters, 1);
    },
    restoreFiltersFromQuery() {
      const { query } = this.$route;
      this.persistFilters = {
        client_id: query?.client_id || null,
        patient_id: query?.patient_id || null,
        program_uuid: query?.program_uuid || null,
        account_uuid: query?.account_uuid || null,
        has_problematic_block_flags: query?.tab === 'blocked_transactions',
      };

      if (query?.event_date_start) {
        this.persistFilters.event_date_start = query.event_date_start;
        this.persistFilters.event_date_end = query.event_date_end;
      }
    },
    setParamsToQuery() {
      const query = {
        tab: this.tabs[this.selectedTab].key || 'transactions',
        ...this.persistFilters,
      };

      const newQuery = new URLSearchParams(query).toString();
      const currentQuery = new URLSearchParams(this.$route.query).toString();

      if (newQuery !== currentQuery) {
        this.$router.replace({ query });
      }
    },
  },
};
</script>
